import React from 'react';
import SearchHistory from '../components/SearchHistory/SearchHistory';

const SearchHistoryPage = () => {
  return <SearchHistory />;
};

export default SearchHistoryPage;